export const clients = {
    amesankoh: {
        name: { ja: "Amesankoh", en: "Amesankoh" },
        company: { country: "germany" },
        target: { regions: ["europe"], countries: [] },
        industryTags: ["apparel", "goods"],
        website: "https://amesankoh.com/",
        overview: {
            ja: "ドイツ発祥の日本の雑貨ブランド。",
            en: "A Japanese lifestyle brand originated in Germany.",
        },
    },
    daeyang: {
        name: { ja: "Dae-Yang GmbH", en: "Dae-Yang GmbH" },
        company: { country: "germany" },
        target: { regions: ["europe"], countries: [] },
        industryTags: ["food"],
        website: "https://dae-yang.online/",
        overview: {
            ja: "デュッセルドルフにある日本食小売店。",
            en: "A Japanese food retail store in Düsseldorf.",
        },
    },
    hayashiseimenjo: {
        name: { ja: "林製麺所", en: "Hayashi Seimenjo", },
        company: { country: "japan" },
        target: { regions: ["europe"], countries: [], },
        industryTags: ["noodles", "food"],
        website: "https://hayashi-seimen.eu/",
        overview: {
            ja: "日本の名古屋で老舗の製麺会社。1947年から続き、日本では800店舗以上の取り扱い店舗のある老舗製麺所。",
            en: "A long-established noodle manufacturer founded in 1947, with products carried in over 800 stores across Japan.",
        },
    },
    imoriichiba: {
        name: { ja: "IMORI ICHIBA", en: "IMORI ICHIBA", },
        company: { country: "germany", },
        target: { regions: ["europe"], countries: [], },
        industryTags: ["food", "restaurant"],
        website: "https://www.iimori-ichiba.com/",
        overview: {
            ja: "ドイツのフランクフルトの日系小売販売・飲食会社。",
            en: "A Japanese retail and food service company based in Frankfurt, Germany.",
        },
    },
    japanfes: {
        name: { ja: "Japan Fes", en: "Japan Fes" },
        company: { country: "belgium" },
        target: { regions: [], countries: ["belgium"] },
        industryTags: ["event"],
        website: "https://www.japanfes.be/",
        overview: {
            ja: "ベルギー最大の日本イベント。",
            en: "The largest Japanese event in Belgium.",
        },
    },
    tagawa: {
        name: { ja: "田川", en: "Tagawa" },
        company: { country: "belgium" },
        target: { regions: [], countries: ["belgium"] },
        industryTags: ["food"],
        website: "https://www.tagawa.eu/",
        overview: {
            ja: "ベルギーに5店舗ある日系食品小売店。",
            en: "A Japanese food retail store with 5 locations in Belgium.",
        },
    },
    beikamochi: {
        name: { ja: "Beika Mochi", en: "Beika Mochi" },
        company: { country: "japan" },
        target: { regions: ["europe"], countries: [], },
        industryTags: ["food"],
        website: "https://beikamochi.eu/",
        overview: {
            ja: "Beika Mochiは、1947年に新潟で創業した老舗米菓メーカー。100％国産米を使った米菓は、ヨーロッパ、アメリカでも大人気。",
            en: "Beika Mochi was founded in Niigata in 1947 and is a long-established Japanese rice snack manufacturer. Its rice crackers, made with 100% domestically grown Japanese rice, are highly popular in both Europe and the United States.",
        },
    },
    satoseiyaku: {
        name: { ja: "佐藤製薬", en: "Sato Pharmaceutical Co., Ltd." },
        company: { country: "japan" },
        target: { regions: ["europe"], countries: [], },
        industryTags: ["pharmaceutical"],
        website: "https://new.sato-pharmaceutical.de/de/",
        overview: {
            ja: "日本本社の製薬会社の欧州拠点 創業：1915年（本社） 住所：Berliner Allee 2640212 Düsseldorf ドイツ拠点では販売・マーケティング機能を担う",
            en: "A European subsidiary of a Japan-based pharmaceutical company, originally established in 1915. Address: Berliner Allee 26, 40212 Düsseldorf, Germany The German office is responsible for sales and marketing activities.",
        },
    },
    mikan: {
        name: { ja: "Mikan", en: "Mikan" },
        company: { country: "japan" },
        target: { regions: ["europe"], countries: [], },
        industryTags: ["goods", "apparel"],
        website: "https://mikan-ec.com/",
        overview: {
            ja: "日本の伝統工芸品・食品・雑貨などを欧州の消費者へ紹介・販売する越境ECプラットフォーム。",
            en: "Mikan is a cross-border e-commerce platform that introduces and sells Japanese traditional crafts, food products, miscellaneous goods, and other items to consumers in Europe.",
        },
    },

};
